import React from 'react';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import { Assignment } from '@material-ui/icons';
import { nDecimal } from 'hooks/Pipe';

export default function ReadPurchaseData(props) {
  const { dataProduct } = props;

  return (
    <>
      <GridItem xs={12} sm={12} md={6}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Artículo compra</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} md={3}>
                <h6>U.M. compra</h6>
                <p>{dataProduct.BuyUnitMsr_UgpName || '-'}</p>
              </GridItem>
              <GridItem xs={12} md={3}>
                <h6>Unidades compra</h6>
                <p>{nDecimal(dataProduct.NumInBuy) || '-'}</p>
              </GridItem>
              <GridItem xs={12} md={3}>
                <h6>Precio compra</h6>
                <p>{dataProduct.purchase_price || '-'}</p>
              </GridItem>
              <GridItem xs={12} md={3}>
                <h6>Impuesto</h6>
                <p>{dataProduct.TaxCodeAP || '-'}</p>
              </GridItem>

              <GridItem xs={12} md={3}>
                <h6>Último precio de compra</h6>
                <p>{dataProduct.last_purchase_price || '-'}</p>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Medidas</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} md={4}>
                <h6>Logintud</h6>
                <p>{nDecimal(dataProduct.BLength1)}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Ancho</h6>
                <p>{nDecimal(dataProduct.BWidth1)}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Altura</h6>
                <p>{nDecimal(dataProduct.BHeight1)}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Unid. volumen</h6>
                <p>{dataProduct.BVolUnit_VolDisply || '-'}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Volumen</h6>
                <p>{nDecimal(dataProduct.BVolume)}</p>
              </GridItem>
              <GridItem xs={12} md={4}>
                <h6>Peso</h6>
                <p>{nDecimal(dataProduct.BWeight1)}</p>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </>
  );
}
